import { render, staticRenderFns } from "./weixue.vue?vue&type=template&id=1c732873"
import script from "./weixue.vue?vue&type=script&lang=ts"
export * from "./weixue.vue?vue&type=script&lang=ts"
import style0 from "./weixue.vue?vue&type=style&index=0&id=1c732873&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports